import { render, staticRenderFns } from "./ListLaborCompleted.vue?vue&type=template&id=717c845f"
import script from "./ListLaborCompleted.vue?vue&type=script&lang=js"
export * from "./ListLaborCompleted.vue?vue&type=script&lang=js"
import style0 from "./ListLaborCompleted.vue?vue&type=style&index=0&id=717c845f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports